import React from "react";
import CellChangeIndicator from "src/components/MyGarage/TableCompare/Cells/CellChangeIndicator";
import { Feature } from "src/components/MyGarage/TableCompare/lib";
import { VehicleState } from "Types/state";

interface DealerOfferVehicleFeaturesProps {
    featureList: Feature[];
    vehicle: VehicleState;
}

export interface DealerOfferCellProps {
    value: string;
    vin: string;
    title: string;
}

const DealerOfferVehicleFeatures = ({ vehicle, featureList }: DealerOfferVehicleFeaturesProps) => {
    return (
        <>
            {featureList.map((feature) => {
                const CellType = feature.cellType;

                return (
                    <CellChangeIndicator
                        key={feature.id}
                        featureId={feature.id}
                        hasChanged={
                            (vehicle &&
                                !vehicle.loading &&
                                feature.hasChanged &&
                                feature.hasChanged(vehicle?.vin, "dealer", "")) ??
                            false
                        }
                    >
                        <CellType
                            vin={vehicle.vin}
                            value={feature.dataFunction && feature.dataFunction(vehicle)}
                            title={feature.label}
                        />
                    </CellChangeIndicator>
                );
            })}
        </>
    );
};

export default DealerOfferVehicleFeatures;
